{
  "page_count": "на {n, plural, one{# страница} other{# страници}}"
}
